import { ApiClient } from "@/shared/services/api-client";
import {
  FirstAuthCompletedInitGetRequestModel,
  FirstAuthCompletedInitGetResponseModel,
} from "@/features/user/services/first-auth-completed-model";
import { HttpResponse } from "@/shared/config/globals";

export class FirstAuthCompletedApi {
  /**
   * 利用者ID初回認証完了ページ表示前処理API
   */
  public firstAuthCompletedInit = async (
    param: FirstAuthCompletedInitGetRequestModel
  ): Promise<HttpResponse<FirstAuthCompletedInitGetResponseModel>> => {
    const path = `/api/first_auth_completed/init`;

    const res = await ApiClient.instance.get<FirstAuthCompletedInitGetResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    return res;
  };
}
